(function () {
  const root = document.querySelector('.val-about-consumer');
  if (!root) return;

  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const hero = root.querySelector('.val-about__hero');
  const pan = root.querySelector('.val-about__hero-pan');
  const papers = root.querySelectorAll('.val-about__paper-open img');
  const dialog = root.querySelector('[data-about-dialog]');
  const dialogImage = root.querySelector('[data-about-dialog-image]');
  const dialogCaption = root.querySelector('[data-about-dialog-caption]');
  const desktopQuery = window.matchMedia('(min-width: 981px)');

  if (!reduce && hero) {
    let ticking = false;
    const update = function () {
      ticking = false;
      const rect = hero.getBoundingClientRect();
      const height = Math.max(rect.height, 1);
      const progress = Math.min(1, Math.max(0, -rect.top / height));
      root.style.setProperty('--about-hero-progress', progress.toFixed(3));

      if (pan) {
        const amount = desktopQuery.matches ? 10 : 6;
        pan.style.transform = 'translate3d(0,' + (progress * amount).toFixed(2) + '%,0)';
      }

      papers.forEach(function (img, index) {
        const paperRect = img.getBoundingClientRect();
        const view = window.innerHeight || 1;
        const mid = paperRect.top + paperRect.height * 0.4;
        const shift = ((mid / view) - 0.5) * (index === 0 ? -16 : -10);
        img.style.setProperty('--about-paper-shift', shift.toFixed(1) + 'px');
      });
    };

    window.addEventListener(
      'scroll',
      function () {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(update);
      },
      { passive: true }
    );

    update();
  }

  if (dialog && dialogImage) {
    root.querySelectorAll('[data-about-viewer]').forEach(function (button) {
      button.addEventListener('click', function () {
        dialogImage.src = button.getAttribute('data-viewer-src') || '';
        dialogImage.alt = button.getAttribute('data-viewer-alt') || '';
        if (dialogCaption) {
          dialogCaption.textContent = button.getAttribute('data-viewer-caption') || '';
        }
        if (typeof dialog.showModal === 'function') {
          dialog.showModal();
        }
      });
    });

    dialog.addEventListener('click', function (event) {
      if (event.target === dialog) dialog.close();
    });
  }

  if (reduce || root.dataset.revealOnScroll !== 'true') return;

  document.documentElement.classList.add('val-about-motion');

  const observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-in');
        observer.unobserve(entry.target);
      });
    },
    { root: null, rootMargin: '0px 0px -8% 0px', threshold: 0.08 }
  );

  const reveal = function (scope) {
    scope.querySelectorAll('.val-about__rise').forEach(function (node) {
      node.classList.add('val-about__rise');
      observer.observe(node);
    });
  };

  reveal(root);

  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (event) {
      if (event.target.contains(root) || root.contains(event.target)) {
        reveal(event.target);
      }
    });
  }
})();
